import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { auth } from "../config/firebase";
import { FirebaseUser } from "../types/firebase";

interface ProfileAuthEditModalProps {
    show: boolean;
    onHide: () => void;
    user: FirebaseUser | null;
    userEmail: string;
    setUserEmail: (email: string) => void;
}

function ProfileAuthEditModal({ show, onHide, user, userEmail, setUserEmail }: ProfileAuthEditModalProps) {
    const [newPassword1, setNewPassword1] = useState<string | null>(null);
    const [newPassword2, setNewPassword2] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);

    const handlePasswordUpdate = () => {
        if (!user) {
            setError("No user logged in");
            return;
        }

        if (newPassword1 && newPassword2) {
            if (newPassword1 > '' && newPassword1 === newPassword2) {
                user.updatePassword(newPassword1).then(() => {
                    console.log("Password updated!");
                    setNewPassword1(null);
                    setNewPassword2(null);
                    onHide();
                }).catch((error) => {
                    console.error("Error updating password:", error);
                    setError("Failed to update password. Please try again.");
                });
            } else {
                setError("Passwords do not match");
            }
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Update Password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <div className="text-danger mb-3">{error}</div>}
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                            type="password"
                            value={newPassword1 || ''}
                            onChange={(e) => setNewPassword1(e.target.value)}
                            placeholder="Enter new password"
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Confirm New Password</Form.Label>
                        <Form.Control
                            type="password"
                            value={newPassword2 || ''}
                            onChange={(e) => setNewPassword2(e.target.value)}
                            placeholder="Confirm new password"
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handlePasswordUpdate}>
                    Update Password
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ProfileAuthEditModal;